import { combineReducers } from 'redux'

import notifications from './notifications'
import isCallAccepted from './isCallAccepted'

export default combineReducers({
  notifications,
  isCallAccepted,
})
